import http from "../core/http";
import { withFlightDateCache } from "../cache/flightListCache";
const group = 'transferBags';

export const getDataListRequest =  async (data) => {
    return await http.post(`${group}/get`, data).then(res => res.data).catch(http.defaultCatch);
}

export const isDisplayedRequest =  async (data) => {
    return await http.post(`${group}/isDisplayed`, data).then(res => res.data).catch(http.defaultCatch);
}

export const createDataRequest =  async (data) => {
    return await http.post(`${group}/create`, data).then(res => res.data).catch(http.defaultCatch);
}

export const updateDataRequest =  async (data) => {
    return await http.post(`${group}/update`, data).then(res => res.data).catch(http.defaultCatch);
}

export const createNoteRequest =  async (data) => {
	return await http.post(`${group}/createNote`, data).then(res => res.data).catch(http.defaultCatch);
}

export const deleteDataRequest =  async (data) => {
    return await http.post(`${group}/delete`, data).then(res => res.data).catch(http.defaultCatch);
}

export const deletePtmFileRequest = async (data) => {
	return await http.post(`${group}/deletePtmFile`, data).then((res) => res.data).catch(http.defaultCatch);
};

export const getArrivalFlightListRequest = async (data) =>
	withFlightDateCache(`${group}/getArrivalFlightList`, data, (d) =>
		http.post(`${group}/getArrivalFlightList`, d).then((res) => res.data).catch(http.defaultCatch)
	);

export const getDepartureFlightListRequest = async (data) =>
	withFlightDateCache(`${group}/getDepartureFlightList`, data, (d) =>
		http.post(`${group}/getDepartureFlightList`, d).then((res) => res.data).catch(http.defaultCatch)
	);